import {createModel} from "@rematch/core";

import {RootModel} from "./index";
import * as api from "../apis/app";
import * as qiniu from "../utils/qiniu"

export interface SiteConfigs {
    title: string,
    icp: string,
    copyright: string,
    // logo: string,
    // favicon: string,
    // background: string
}

interface AppState {
    siteConfigs: SiteConfigs | undefined
}

const initState: AppState = {
    siteConfigs: undefined,
}

export const app = createModel<RootModel>()({
        state: initState,
        reducers: {
            setSiteConfigs: (state: AppState, payload: SiteConfigs) => ({...state, siteConfigs: payload}),
        },
        effects: (dispatch) => ({
            async loadSiteConfigs() {
                const response = await api.getSiteConfigurations()
                dispatch.app.setSiteConfigs({
                    title: response.data.data['site-title'],
                    icp: response.data.data['site-icp'],
                    copyright: response.data.data['site-copyright'],
                    // logo: qiniu.getUrl(response.data.data['site-logo']),
                    // favicon: qiniu.getUrl(response.data.data['site-favicon']),
                    // background: qiniu.getUrl(response.data.data['site-background']),
                })
            }
        })
    }
)